<template>
  <div class="light">
    <!--    <div class="logo"></div>-->
    <!--    <div class="lang-select">-->
    <!--      <LangSelect />-->
    <!--    </div>-->
    <div class="logo-form">
      <LoginForm />
    </div>
    <div class="logo-footer">
      <!--      <div>Copyright © 银都餐饮设备股份有限公司</div>-->
      <!--      <div>浙ICP备15015690号-1</div>-->
    </div>
  </div>
</template>

<script>
import LoginForm from './LoginForm'
// import LangSelect from '@/components/LangSelect'
export default {
  components: {
    LoginForm
    // LangSelect
  }
}
</script>

<style lang="scss" scoped>
.light {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 90px;
  background-image: url('../../assets/light_login_bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  .logo {
    margin: 0 auto;
    width: 220px;
    height: 60px;
    //background-image: url('../../assets/light_login_logo.png');
    background-image: url('../../assets/logo@2x.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .lang-select {
    margin: -40px 24px auto auto;
    width: 160px;
    height: 40px;
  }
  .logo-form {
    position: absolute;
    top: 34%;
    left: 75%;
    margin-left: -200px;
    margin-top: -214px;
    width: 432px;
    height: 680px;
  }
  .logo-footer {
    position: absolute;
    left: 0;
    bottom: 48px;
    width: 100%;
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    text-align: center;
  }
}
</style>
